module.exports = __webpack_public_path__ + "static/zhentarim_agent_with_flying_snake-834930ee244c4d1bf8fae6c5d83e4930.png";